var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 1.99992C8.66683 1.63173 8.36835 1.33325 8.00016 1.33325C7.63197 1.33325 7.3335 1.63173 7.3335 1.99992V8.39044L5.13823 6.19518C4.87788 5.93483 4.45577 5.93483 4.19543 6.19518C3.93508 6.45553 3.93508 6.87764 4.19543 7.13799L7.52828 10.4708L7.53313 10.4757C7.59603 10.5374 7.66813 10.5842 7.74497 10.616C7.823 10.6484 7.9085 10.6663 7.99816 10.6666L8.00016 10.6666L8.00216 10.6666C8.18325 10.6661 8.34735 10.5933 8.4672 10.4757L8.47204 10.4708L11.8049 7.13799C12.0653 6.87764 12.0653 6.45553 11.8049 6.19518C11.5446 5.93483 11.1224 5.93483 10.8621 6.19518L8.66683 8.39044V1.99992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 9.99992C2.66683 9.63173 2.36835 9.33325 2.00016 9.33325C1.63197 9.33325 1.3335 9.63173 1.3335 9.99992V12.6666C1.3335 13.7681 2.23197 14.6666 3.3335 14.6666H12.6668C13.7684 14.6666 14.6668 13.7681 14.6668 12.6666V9.99992C14.6668 9.63173 14.3684 9.33325 14.0002 9.33325C13.632 9.33325 13.3335 9.63173 13.3335 9.99992V12.6666C13.3335 13.0317 13.032 13.3333 12.6668 13.3333H3.3335C2.96835 13.3333 2.66683 13.0317 2.66683 12.6666V9.99992Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1ab1e0f3.svg";
export { ForwardRef as ReactComponent };